import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function TerminalWindow() {
  const [searchParams] = useSearchParams();
  const sessionName = searchParams.get('session') || 'Terminal';
  const tmuxName = searchParams.get('tmux') || '';
  const terminalUrl = 'https://jmgdev.tail68ddf4.ts.net';

  // Set the document title to the session name
  useEffect(() => {
    document.title = `${sessionName} - Terminal`;
    return () => {
      document.title = 'Mission Control HUD';
    };
  }, [sessionName]);

  const iframeUrl = `${terminalUrl}/?arg=${encodeURIComponent(tmuxName)}`;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      margin: 0,
      padding: 0,
      overflow: 'hidden',
      backgroundColor: '#000',
    }}>
      <iframe
        src={iframeUrl}
        title={sessionName}
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
        }}
        allow="clipboard-read; clipboard-write"
      />
    </div>
  );
}
